import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: min(90%, 600px);
  margin: 2rem auto 0 auto;
  gap: 1rem;
  align-items: center;
`;
